import { call, put, takeLatest } from "redux-saga/effects";
import { ToastError, ToastSuccess } from "components/Global/Toasts/Toasty";
import {
  defaultReturn
  , multipleObjectReturn
  , makePayload
  , generateDefaultActions
  , requestSaga
  , handleCallback
  , subKeySaga
} from "shared-utility/store/utils/helpers";

// ACTIONS
export const HOLIDAY_CALENDAR_GET_COUNTRY_CODES = generateDefaultActions("HOLIDAY_CALENDAR_GET_COUNTRY_CODES");
export const getCountryCodes = payload => makePayload(HOLIDAY_CALENDAR_GET_COUNTRY_CODES.value, payload);
function* getCountryCodesSaga(payload) {
  const callback = handleCallback(payload);
  const url = "/configItemsByParents";
  const requestSaga = subKeySaga("08a7300d-2c3b-11ec-ab1a-98fa9bde2f84");
  yield requestSaga(HOLIDAY_CALENDAR_GET_COUNTRY_CODES, url, "post", { parentIds: ["08a7300d-2c3b-11ec-ab1a-98fa9bde2f84"] });
  yield callback();
}
export const HOLIDAY_CALENDAR_GET_HOLIDAYS = generateDefaultActions("HOLIDAY_CALENDAR_GET_HOLIDAYS");
export const getHolidays = payload => makePayload(HOLIDAY_CALENDAR_GET_HOLIDAYS.value, payload);
function* getHolidaysSaga(payload) {
  const callback = handleCallback(payload);
  const url = "/getHolidays";
  yield requestSaga(HOLIDAY_CALENDAR_GET_HOLIDAYS, url, "GET");
  yield callback();
}
export const HOLIDAY_CALENDAR_GET_HOLIDAY_BY_ID = generateDefaultActions("HOLIDAY_CALENDAR_GET_HOLIDAY_BY_ID");
export const getHolidayById = payload => makePayload(HOLIDAY_CALENDAR_GET_HOLIDAY_BY_ID.value, payload);
function* getHolidayByIdSaga(payload) {
  const callback = handleCallback(payload);
  const url = `/getHolidayById/${payload.id}`;
  yield requestSaga(HOLIDAY_CALENDAR_GET_HOLIDAY_BY_ID, url, "GET");
  yield callback();
}
export const HOLIDAY_CALENDAR_GET_ALL_BY_COUNTRY = generateDefaultActions("HOLIDAY_CALENDAR_GET_ALL_BY_COUNTRY");
export const getAllByCountry = payload => makePayload(HOLIDAY_CALENDAR_GET_ALL_BY_COUNTRY.value, payload);
function* getAllByCountrySaga(payload) {
  const callback = handleCallback(payload);
  const url = `/getAllByCountry/${payload.country}/${payload.year}?`;
  yield requestSaga(HOLIDAY_CALENDAR_GET_ALL_BY_COUNTRY, url, "GET");
  yield callback();
}
export const HOLIDAY_CALENDAR_GET_HOLIDAY_BY_DATE = generateDefaultActions("HOLIDAY_CALENDAR_GET_HOLIDAY_BY_DATE");
export const getHolidayByDate = payload => makePayload(HOLIDAY_CALENDAR_GET_HOLIDAY_BY_DATE.value, payload);
function* getHolidayByDateSaga(payload) {
  const callback = handleCallback(payload);
  const url = `/getHolidayByDate/${payload.date}`;
  yield requestSaga(HOLIDAY_CALENDAR_GET_HOLIDAY_BY_DATE, url, "GET");
  yield callback();
}
export const HOLIDAY_CALENDAR_ADD_HOLIDAY = generateDefaultActions("HOLIDAY_CALENDAR_ADD_HOLIDAY");
export const addHoliday = payload => makePayload(HOLIDAY_CALENDAR_ADD_HOLIDAY.value, payload);
function* addHolidaySaga(payload) {
  const callback = handleCallback(payload);
  const url = "/addHoliday";
  yield requestSaga(HOLIDAY_CALENDAR_ADD_HOLIDAY, url, "POST", payload);
  yield callback();
}
export const HOLIDAY_CALENDAR_UPDATE_HOLIDAY = generateDefaultActions("HOLIDAY_CALENDAR_UPDATE_HOLIDAY");
export const updateHoliday = payload => makePayload(HOLIDAY_CALENDAR_UPDATE_HOLIDAY.value, payload);
function* updateHolidaySaga(payload) {
  const callback = handleCallback(payload);
  const url = "/updateHoliday";
  yield requestSaga(HOLIDAY_CALENDAR_UPDATE_HOLIDAY, url, "POST", payload);
  yield callback();
}
export const HOLIDAY_CALENDAR_REFRESH_HOLIDAYS = generateDefaultActions("HOLIDAY_CALENDAR_REFRESH_HOLIDAYS");
export const refreshHolidays = payload => makePayload(HOLIDAY_CALENDAR_REFRESH_HOLIDAYS.value, payload);
function* refreshHolidaysSaga(payload) {
  const callback = handleCallback(payload);
  const url = "/refreshHolidays";
  yield requestSaga(HOLIDAY_CALENDAR_REFRESH_HOLIDAYS, url, "POST", payload);
  yield callback();
}
export const HOLIDAY_CALENDAR_REFRESH_HOLIDAY_DATE_RANGE = generateDefaultActions("HOLIDAY_CALENDAR_REFRESH_HOLIDAY_DATE_RANGE");
export const refreshHolidayDateRange = payload => makePayload(HOLIDAY_CALENDAR_REFRESH_HOLIDAY_DATE_RANGE.value, payload);
function* refreshHolidayDateRangeSaga(payload) {
  const callback = handleCallback(payload);
  const url = "/refreshHolidayDateRange";
  yield requestSaga(HOLIDAY_CALENDAR_REFRESH_HOLIDAY_DATE_RANGE, url, "POST", payload);
  yield callback();
}
export const HOLIDAY_CALENDAR_REFRESH_SINGLE_HOLIDAY = generateDefaultActions("HOLIDAY_CALENDAR_REFRESH_SINGLE_HOLIDAY");
export const refreshSingleHoliday = payload => makePayload(HOLIDAY_CALENDAR_REFRESH_SINGLE_HOLIDAY.value, payload);
function* refreshSingleHolidaySaga(payload) {
  const callback = handleCallback(payload);
  const url = "/refreshSingleHoliday";
  yield requestSaga(HOLIDAY_CALENDAR_REFRESH_SINGLE_HOLIDAY, url, "POST", payload);
  yield callback();
}
export const HOLIDAY_CALENDAR_DELETE_HOLIDAY = generateDefaultActions("HOLIDAY_CALENDAR_DELETE_HOLIDAY");
export const deleteHoliday = payload => makePayload(HOLIDAY_CALENDAR_DELETE_HOLIDAY.value, payload);
function* deleteHolidaySaga(payload) {
  const callback = handleCallback(payload);
  const url = `/deleteHoliday/${payload.id}`;
  yield requestSaga(HOLIDAY_CALENDAR_DELETE_HOLIDAY, url, "DELETE");
  yield callback();
}

// REDUCER

const initialState = {
  countryCodes: [],
  holidays: [],
  holiday: {}
};

export function holidayCalendarReducer(state = initialState, action) {
  const { type, payload, subKey } = action;
  switch (type) {
    case HOLIDAY_CALENDAR_GET_COUNTRY_CODES.success:
      return defaultReturn(state, payload[subKey], "countryCodes");

    case HOLIDAY_CALENDAR_GET_COUNTRY_CODES.failure:
      ToastError("Data Fetch Unsuccessful");

      return defaultReturn(state);

    case HOLIDAY_CALENDAR_GET_HOLIDAYS.success:
      ToastSuccess("Data Loaded");

      return defaultReturn(state, payload, "holidays");

    case HOLIDAY_CALENDAR_GET_HOLIDAYS.failure:
      ToastError("Data Fetch Unsuccessful");

      return defaultReturn(state);

    case HOLIDAY_CALENDAR_GET_HOLIDAY_BY_ID.success:
      return defaultReturn(state, payload, "holiday");

    case HOLIDAY_CALENDAR_GET_HOLIDAY_BY_ID.failure:
      ToastError("Data Fetch Unsuccessful");

      return defaultReturn(state);

    case HOLIDAY_CALENDAR_GET_ALL_BY_COUNTRY.success:
      ToastSuccess("Data Loaded");

      return defaultReturn(state, payload, "holidays");

    case HOLIDAY_CALENDAR_GET_ALL_BY_COUNTRY.failure:
      ToastError("Data Fetch Unsuccessful");

      return defaultReturn(state);

    case HOLIDAY_CALENDAR_GET_HOLIDAY_BY_DATE.success:
      ToastSuccess("Data Loaded");

      return defaultReturn(state, payload, "holidays");

    case HOLIDAY_CALENDAR_GET_HOLIDAY_BY_DATE.failure:
      ToastError("Data Fetch Unsuccessful");

      return defaultReturn(state);

    case HOLIDAY_CALENDAR_ADD_HOLIDAY.success:
      return defaultReturn(state);

    case HOLIDAY_CALENDAR_ADD_HOLIDAY.failure:
      ToastError("Data Fetch Unsuccessful");

      return defaultReturn(state);

    case HOLIDAY_CALENDAR_UPDATE_HOLIDAY.success:
      return defaultReturn(state);

    case HOLIDAY_CALENDAR_UPDATE_HOLIDAY.failure:
      ToastError("Data Fetch Unsuccessful");

      return defaultReturn(state);

    case HOLIDAY_CALENDAR_REFRESH_HOLIDAYS.success:
      ToastSuccess("Refreshed");

      return defaultReturn(state);

    case HOLIDAY_CALENDAR_REFRESH_HOLIDAYS.failure:
      ToastError("Data Fetch Unsuccessful");

      return defaultReturn(state);

    case HOLIDAY_CALENDAR_REFRESH_HOLIDAY_DATE_RANGE.success:
      ToastSuccess("Refreshed");

      return defaultReturn(state);

    case HOLIDAY_CALENDAR_REFRESH_HOLIDAY_DATE_RANGE.failure:
      ToastError("Data Fetch Unsuccessful");

      return defaultReturn(state);

    case HOLIDAY_CALENDAR_REFRESH_SINGLE_HOLIDAY.success:
      ToastSuccess("Refreshed");

      return defaultReturn(state);

    case HOLIDAY_CALENDAR_REFRESH_SINGLE_HOLIDAY.failure:
      ToastError("Data Fetch Unsuccessful");

      return defaultReturn(state);

    case HOLIDAY_CALENDAR_DELETE_HOLIDAY.success:
      ToastSuccess("Deleted");

      return defaultReturn(state);

    case HOLIDAY_CALENDAR_DELETE_HOLIDAY.failure:
      ToastError("Data Fetch Unsuccessful");

      return defaultReturn(state);

      // DEFAULT
    default:
      return state;
  }
}

// SAGA

export function* holidayCalendarSaga() {
  yield takeLatest(HOLIDAY_CALENDAR_GET_HOLIDAYS.value, getHolidaysSaga);
  yield takeLatest(HOLIDAY_CALENDAR_GET_HOLIDAY_BY_ID.value, getHolidayByIdSaga);
  yield takeLatest(HOLIDAY_CALENDAR_GET_ALL_BY_COUNTRY.value, getAllByCountrySaga);
  yield takeLatest(HOLIDAY_CALENDAR_GET_HOLIDAY_BY_DATE.value, getHolidayByDateSaga);
  yield takeLatest(HOLIDAY_CALENDAR_ADD_HOLIDAY.value, addHolidaySaga);
  yield takeLatest(HOLIDAY_CALENDAR_UPDATE_HOLIDAY.value, updateHolidaySaga);
  yield takeLatest(HOLIDAY_CALENDAR_REFRESH_HOLIDAYS.value, refreshHolidaysSaga);
  yield takeLatest(HOLIDAY_CALENDAR_REFRESH_HOLIDAY_DATE_RANGE.value, refreshHolidayDateRangeSaga);
  yield takeLatest(HOLIDAY_CALENDAR_REFRESH_SINGLE_HOLIDAY.value, refreshSingleHolidaySaga);
  yield takeLatest(HOLIDAY_CALENDAR_DELETE_HOLIDAY.value, deleteHolidaySaga);
  yield takeLatest(HOLIDAY_CALENDAR_GET_COUNTRY_CODES.value, getCountryCodesSaga);
}

